import { createAppRequest } from '@/services/request';
import type { ApiRequestOptions } from './types/common';
import type {
  CreateFamsProjectManagementPayload,
  FamsProjectCategoryOptionsResponse,
  FamsProjectManagementItem,
  FamsProjectManagementListParams,
  FamsProjectManagementListResponse,
  UpdateFamsProjectManagementPayload,
} from './types/project-management';

const request = createAppRequest();



export async function getFamsProjectManagementCategoryOptions(options?: ApiRequestOptions) {
  return request<FamsProjectCategoryOptionsResponse>('/bff/fams/project-management/category-options', {
    method: 'GET',
    ...(options || {}),
  });
}



